var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAccountMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 25C29.0751 25 34 20.0751 34 14C34 7.92487 29.0751 3 23 3C16.9249 3 12 7.92487 12 14C12 20.0751 16.9249 25 23 25Z",
    stroke: "#020202",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 46.9581L3.70476 42.6629C4.53733 37.7023 6.92331 33.2193 10.4482 29.9926C13.9731 26.7659 18.4142 24.9994 23 25C27.5912 25.0012 32.0367 26.7737 35.5624 30.0087C39.088 33.2438 41.4706 37.7365 42.2952 42.7048L43 47",
    stroke: "#020202",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccountMenu);
export default __webpack_public_path__ + "static/media/icon_account-menu.cf72faa39da37aa866a426998a5e7027.svg";
export { ForwardRef as ReactComponent };